import { render, staticRenderFns } from "./AccountTypesView.vue?vue&type=template&id=ad64a1a0&lang=pug&"
import script from "./AccountTypesView.vue?vue&type=script&lang=js&"
export * from "./AccountTypesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports